/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {ClickOutsideDirective as ɵa} from './src/directives/click-outside/click-outside.directive';